export default function getEnvVars(): {
  API_HOST: string
  VERSION: string
  NODE_ENV: 'production' | 'development'
  ENV: 'prod' | 'stage' | 'dev' | 'local'
} {
  const {
    VUE_APP_API_HOST: API_HOST,
    NODE_ENV,
    VERSION,
    VUE_APP_ENV: ENV,
  } = process.env
  return {
    API_HOST,
    VERSION,
    NODE_ENV,
    ENV,
  }
}
